import { createSlice } from '@reduxjs/toolkit';
import { getSiteActivityData as fetchSiteActivityDataAPI } from '../../../apis/siteAPI';
import { ACTIONS_SITE_ACTIVITY } from '../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { handlePending, handleRejection } from '../../../constants';
import { initialState } from '../../../data/entitlement/siteActivity/initialState.siteActivity.data';

export const fetchSIteActivityData = createAsyncThunkWrapper(
  ACTIONS_SITE_ACTIVITY.FETCH_SITE_ACTIVITY,
  fetchSiteActivityDataAPI
);

const siteActivitySlice = createSlice({
  name: 'siteActivity',
  initialState,
  reducers: {
    handleSiteActivitySelectedRow: (state, action) => {
      state.siteActivitySelectedRowData = action?.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSIteActivityData.pending, (state, action) => {
        handlePending(state, action);
        state.siteActivityData = [];
        state.isRecordsFound = null;
        state.loading = true;
        state.totalRecords = 0;
      })
      .addCase(fetchSIteActivityData.fulfilled, (state, action) => {
        state.loading = false;
        const fromThisSiteRows = action?.payload?.fromThisSite?.map(
          (item, index) => ({
            id: index,
            fromThisSite: true,
            ...item,
          })
        );
        const toThisSiteRows = action?.payload?.toThisSite?.map(
          (item, index) => ({
            id: index + fromThisSiteRows.length,
            fromThisSite: false,
            ...item,
          })
        );
        // Merge arrays
        const mergedArray = toThisSiteRows?.length > 0 ? [...fromThisSiteRows, ...toThisSiteRows] : [];
        // Output the merged array
        state.siteActivityData = mergedArray?.sort(
          (a, b) => new Date(b.activityDate) - new Date(a.activityDate)
        );
        state.totalRecords = mergedArray?.length || 0;
        state.isRecordsFound = mergedArray?.length === 0;
      })
      .addCase(fetchSIteActivityData.rejected, (state, action) => {
        handleRejection(state, action);
        state.siteActivityData = [];
        state.isRecordsFound = true;
        state.loading = false;
        state.totalRecords = 0;
      });
  },
});

export const { handleSiteActivitySelectedRow } = siteActivitySlice.actions;
export default siteActivitySlice.reducer;
